<tt-page *ngIf="!!setting">
    <tt-card class="col-xs-12 col-md-3 p-5">
        <tt-select ttRememberId="w_customerinvoicings.businessco_no" ttLabel="businessco" [(ttModel)]="setting.businessco_no" (ttModelChange)="onChanged($event, 'businessco_no')" [ttData]="selectListCompanies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
    </tt-card>

    <tt-grid *ngIf="!!grid" class="flex-1 p-5" [(ttOptions)]="grid"></tt-grid>
</tt-page>
